module.exports = __webpack_public_path__ + "img/photo-27.c6d3ac2f.jpg";